import React, { FormEvent, useEffect, useState } from 'react';
import axios from 'axios';
import { PDFDownloadLink, Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import SideBareMagasin from '../../Views/Magasin/SideBareMagasin/SideBareMagasin';
import { Link, useNavigate } from 'react-router-dom';
import AfficheMagasinsService from './AfficheMagasinsService';
import { MagasinInfo } from '../../Modeles/MagasinModel';
import AfficheClient from './AfficheClient';
import { ClientInfo } from '../../Modeles/Client';
import { NewSideBarMagasins } from '../../Views/NewSidebarMagasin';

const commandeStyles = `
/* =========================================================================
   COMMANDE.CSS — Espace Commande (Pagec)
   Design language: industrial parts & logistics ops console.
   Built on the brand accent (#FFC400) and slate/navy neutrals,
   formalized into a single token system + a "reference tag" signature
   element used for part references throughout (nod to hardware SKU tags).
   ========================================================================= */

:root {
  /* Ink / neutrals */
  --cmd-ink: #1b2333;
  --cmd-ink-soft: #3d4759;
  --cmd-muted: #6b7688;
  --cmd-light: #a4adbd;
  --cmd-border: #e3e7ee;
  --cmd-border-strong: #cbd2e0;
  --cmd-bg: #f5f6f9;
  --cmd-surface: #ffffff;

  /* Brand accent */
  --cmd-gold: #ffc400;
  --cmd-gold-dark: #e0a800;
  --cmd-gold-ink: #7a5900;
  --cmd-gold-dim: #fff6da;

  /* Status */
  --cmd-blue: #1d4ed8;
  --cmd-blue-dim: #eaf1ff;
  --cmd-success: #15803d;
  --cmd-success-dim: #eefbf1;
  --cmd-danger: #dc2626;
  --cmd-danger-dim: #fef2f2;

  /* Geometry */
  --cmd-radius: 16px;
  --cmd-radius-sm: 10px;
  --cmd-radius-pill: 999px;
  --cmd-shadow: 0 1px 2px rgba(20, 24, 38, 0.04), 0 10px 28px rgba(20, 24, 38, 0.07);
  --cmd-shadow-sm: 0 1px 2px rgba(20, 24, 38, 0.06);

  /* Type */
  --font-display: "Lato", "Segoe UI", -apple-system, sans-serif;
  --font-mono: "JetBrains Mono", "SFMono-Regular", Consolas, "Roboto Mono", monospace;
}

/* -------------------------------------------------------------------------
   Base
   ---------------------------------------------------------------------- */

.commande-container,
.container.commande-parent {
  font-family: var(--font-display);
  color: var(--cmd-ink);
  background: var(--cmd-bg);
}

.container.commande-parent {
  display: grid;
  grid-template-columns: 248px 1fr;
  gap: 24px;
  max-width: 1180px;
  margin: 0 auto;
  padding: 24px 20px 60px;
  align-items: start;
}

.btn-bienvenu-espace-commande {
  font-family: var(--font-display);
  font-size: 1.3rem;
  font-weight: 700;
  color: var(--cmd-ink);
  max-width: 1180px;
  margin: 28px auto 0;
  padding: 0 20px;
}

.btn-bienvenu-espace-commande::after {
  content: "";
  display: block;
  width: 42px;
  height: 3px;
  margin-top: 10px;
  background: var(--cmd-gold);
  border-radius: 999px;
}

section h3 {
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--cmd-ink);
  margin: 0 0 4px;
}

section > h3 + p {
  color: var(--cmd-muted);
  font-size: 0.86rem;
  margin: 0 0 18px;
}

/* -------------------------------------------------------------------------
   Loading state
   ---------------------------------------------------------------------- */

.custom-spinner {
  color: var(--cmd-gold-dark) !important;
  border-width: 3px;
}

.loader-charg {
  margin-left: 10px;
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 0.85rem;
  color: var(--cmd-muted);
  letter-spacing: 0.02em;
}

/* -------------------------------------------------------------------------
   Alerts
   ---------------------------------------------------------------------- */

.alert {
  border: none !important;
  border-radius: var(--cmd-radius-sm) !important;
  font-family: var(--font-display);
  font-size: 0.86rem;
  font-weight: 500;
  padding: 12px 16px !important;
  display: flex;
  align-items: center;
  gap: 8px;
}

.alert-danger {
  background: var(--cmd-danger-dim) !important;
  color: #991b1b !important;
}

.alert-success {
  background: var(--cmd-success-dim) !important;
  color: var(--cmd-success) !important;
}

/* -------------------------------------------------------------------------
   Mobile: back bar + stepper (dispatch-ticket rail)
   ---------------------------------------------------------------------- */

.commande-container {
  padding: 18px 16px 90px;
  max-width: 560px;
  margin: 0 auto;
}

.barRetour {
  display: flex;
}

.iconRetour {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: var(--cmd-radius-sm);
  background: var(--cmd-surface);
  border: 1px solid var(--cmd-border);
  color: var(--cmd-ink-soft);
  font-size: 1.2rem;
  cursor: pointer;
  box-shadow: var(--cmd-shadow-sm);
}

.step-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--cmd-surface);
  border: 1px solid var(--cmd-border);
  border-radius: var(--cmd-radius);
  padding: 14px 10px;
  margin-bottom: 20px;
  box-shadow: var(--cmd-shadow-sm);
  position: relative;
}

.step-header::before {
  content: "";
  position: absolute;
  top: 25px;
  left: 15%;
  right: 15%;
  height: 2px;
  background: var(--cmd-border);
  z-index: 0;
}

.step {
  position: relative;
  z-index: 1;
  flex: 1;
  text-align: center;
  color: var(--cmd-light);
  font-weight: 600;
  padding-top: 30px;
}

.step:nth-child(1)::before { content: "1"; }
.step:nth-child(2)::before { content: "2"; }
.step:nth-child(3)::before { content: "3"; }

.step::before {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: var(--cmd-surface);
  border: 2px solid var(--cmd-border-strong);
  color: var(--cmd-muted);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.78rem;
}

.step.active {
  color: var(--cmd-ink);
}

.step.active::before {
  background: var(--cmd-gold);
  border-color: var(--cmd-gold);
  color: var(--cmd-gold-ink);
}

.form-section {
  background: var(--cmd-surface);
  border: 1px solid var(--cmd-border);
  border-radius: var(--cmd-radius);
  padding: 22px 18px;
  box-shadow: var(--cmd-shadow-sm);
}

.form-section h2 {
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--cmd-ink);
}

.form-section span {
  display: block;
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--cmd-muted);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 6px;
}

.form-section > div > button,
.buttons button {
  width: 100%;
}

/* -------------------------------------------------------------------------
   Form controls (shared, mobile + desktop)
   ---------------------------------------------------------------------- */

.commande-container input[type="text"],
.commande-container input[type="number"],
.commande-container textarea,
.commande-container select,
.custom-select,
.content-commande .form-control,
.content-commande input,
.content-commande select,
.content-commande textarea {
  width: 100%;
  font-family: var(--font-display);
  font-size: 0.92rem;
  color: var(--cmd-ink) !important;
  background: var(--cmd-bg);
  border: 1.5px solid var(--cmd-border);
  border-radius: var(--cmd-radius-sm);
  padding: 10px 13px;
  margin-bottom: 16px;
  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
}

.commande-container input:focus,
.commande-container textarea:focus,
.commande-container select:focus,
.content-commande .form-control:focus {
  outline: none;
  border-color: var(--cmd-gold-dark);
  background: var(--cmd-surface);
  box-shadow: 0 0 0 3px var(--cmd-gold-dim);
}

.content-commande .form-control:disabled,
.commande-container input:disabled {
  background: var(--cmd-bg);
  color: var(--cmd-muted) !important;
  cursor: not-allowed;
  opacity: 0.75;
}

.form-label {
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--cmd-muted);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 6px;
  display: block;
}

.quantity-container input {
  max-width: 140px;
}

/* -------------------------------------------------------------------------
   Buttons
   ---------------------------------------------------------------------- */

.commande-container button,
.step-header ~ .form-section button,
.form-section > button,
.buttons button,
.btn-ajoute-interface-commande,
.edit-btn-commande {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 0.88rem;
  border: none;
  border-radius: var(--cmd-radius-sm);
  padding: 11px 20px;
  cursor: pointer;
  transition: transform 0.1s ease, box-shadow 0.15s ease, background 0.15s ease;
}

.commande-container button,
.buttons button,
.form-section button {
  background: var(--cmd-ink);
  color: #fff;
}

.btn-ajoute-interface-commande {
  background: var(--cmd-gold);
  color: var(--cmd-gold-ink);
  box-shadow: var(--cmd-shadow-sm);
}

.btn-ajoute-interface-commande:hover,
.commande-container button:hover {
  transform: translateY(-1px);
  box-shadow: var(--cmd-shadow);
}

.btn-ajoute-interface-commande:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.edit-btn-commande {
  background: var(--cmd-surface);
  color: var(--cmd-ink-soft);
  border: 1.5px solid var(--cmd-border) !important;
  font-size: 0.8rem;
  padding: 7px 14px;
}

.edit-btn-commande:hover {
  border-color: var(--cmd-gold-dark) !important;
}

/* Search row button */
.commande-container button[type="button"] i.bi-search {
  margin-right: 4px;
}

/* -------------------------------------------------------------------------
   Reference search dropdown
   ---------------------------------------------------------------------- */

.resultsref {
  background: var(--cmd-surface) !important;
  border: 1px solid var(--cmd-border);
  border-radius: var(--cmd-radius-sm);
  box-shadow: var(--cmd-shadow);
  margin: -8px 0 16px;
  max-height: 260px;
  overflow-y: auto;
  padding: 4px;
}

.resultref {
  display: block;
  font-size: 0.85rem;
  color: var(--cmd-ink-soft);
  padding: 9px 10px;
  border-radius: 8px;
  cursor: pointer;
  font-family: var(--font-mono);
}

.resultref:hover {
  background: var(--cmd-gold-dim);
  color: var(--cmd-gold-ink);
}

/* -------------------------------------------------------------------------
   Reference tag — signature element used for part references
   ---------------------------------------------------------------------- */

.ref-tag {
  display: inline-flex;
  align-items: center;
  gap: 0;
  font-family: var(--font-mono);
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--cmd-ink-soft);
  background: var(--cmd-bg);
  border: 1px solid var(--cmd-border-strong);
  border-radius: 6px;
  padding: 3px 8px;
  letter-spacing: 0.01em;
}

/* -------------------------------------------------------------------------
   Mobile article summary cards
   ---------------------------------------------------------------------- */

.article-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 18px 0 24px;
}

.article-card {
  position: relative;
  background: var(--cmd-surface);
  border: 1px solid var(--cmd-border);
  border-radius: var(--cmd-radius-sm);
  padding: 14px 16px;
  box-shadow: var(--cmd-shadow-sm);
  font-size: 0.86rem;
  display: grid;
  gap: 4px;
}

.article-card strong {
  color: var(--cmd-muted);
  font-weight: 600;
  font-size: 0.76rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-right: 6px;
}

.article-card div:first-of-type {
  font-family: var(--font-mono);
}

.btn-delete-commande-mobile {
  position: absolute;
  top: 12px;
  right: 14px;
  color: var(--cmd-danger);
  font-size: 1.05rem;
  cursor: pointer;
}

.commande-actions {
  margin: 20px 0 14px;
}

.Vb-mobile {
  display: block;
  text-align: center;
  background: var(--cmd-ink);
  color: #fff !important;
  font-weight: 700;
  border-radius: var(--cmd-radius-sm);
  padding: 13px;
  text-decoration: none !important;
  box-shadow: var(--cmd-shadow-sm);
}

.tbd-mobile {
  width: 100%;
  background: var(--cmd-surface) !important;
  color: var(--cmd-ink-soft) !important;
  border: 1.5px solid var(--cmd-border) !important;
  text-align: left;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* -------------------------------------------------------------------------
   Success popup
   ---------------------------------------------------------------------- */

.popup-success {
  position: fixed;
  inset: 0;
  background: rgba(27, 35, 51, 0.55);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  padding: 20px;
}

.popup-content {
  background: var(--cmd-surface);
  border-radius: var(--cmd-radius);
  padding: 34px 28px;
  text-align: center;
  max-width: 340px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.25);
}

.popup-icon {
  font-size: 2.6rem;
  color: var(--cmd-success);
  margin-bottom: 10px;
}

.popup-content h5 {
  font-weight: 700;
  color: var(--cmd-ink);
  margin-bottom: 6px;
}

.popup-content p {
  color: var(--cmd-muted);
  font-size: 0.85rem;
  margin: 0;
}

/* -------------------------------------------------------------------------
   Desktop: sidebar nav
   ---------------------------------------------------------------------- */

.barleft-commande {
  background: var(--cmd-surface);
  border: 1px solid var(--cmd-border);
  border-radius: var(--cmd-radius);
  padding: 10px;
  box-shadow: var(--cmd-shadow-sm);
  position: sticky;
  top: 24px;
}

.barleft-commande ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.barleft-commande button {
  width: 100%;
  text-align: left;
  background: transparent;
  border: none;
  border-left: 3px solid transparent;
  border-radius: 8px;
  padding: 12px 14px;
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 0.88rem;
  color: var(--cmd-muted);
  cursor: pointer;
  transition: all 0.15s ease;
}

.barleft-commande button:hover {
  background: var(--cmd-bg);
  color: var(--cmd-ink-soft);
  box-shadow: none;
  transform: none;
}

.barleft-commande button.active {
  background: var(--cmd-gold-dim);
  border-left-color: var(--cmd-gold);
  color: var(--cmd-gold-ink);
}

/* -------------------------------------------------------------------------
   Desktop: content card
   ---------------------------------------------------------------------- */

.content-commande {
  background: var(--cmd-surface);
  border: 1px solid var(--cmd-border);
  border-radius: var(--cmd-radius);
  padding: 26px 28px;
  box-shadow: var(--cmd-shadow-sm);
  min-height: 420px;
}

.header-information-client {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}

.header-information-client h3 {
  margin: 0;
}

.info-card {
  background: var(--cmd-bg);
  border: 1px solid var(--cmd-border);
  border-radius: var(--cmd-radius-sm);
  padding: 18px 20px 4px;
}

.info-card .col {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--cmd-muted);
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.info-card label {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--cmd-muted);
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 6px;
  display: block;
}

/* -------------------------------------------------------------------------
   Data table
   ---------------------------------------------------------------------- */

.content-commande table,
table.cmd-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
}

.content-commande thead th {
  text-align: left;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--cmd-muted);
  padding: 10px 12px;
  border-bottom: 2px solid var(--cmd-border);
  white-space: nowrap;
}

.content-commande tbody td {
  padding: 12px;
  border-bottom: 1px solid var(--cmd-border);
  color: var(--cmd-ink-soft);
  vertical-align: middle;
}

.content-commande tbody tr {
  transition: background 0.12s ease;
}

.content-commande tbody tr:hover {
  background: var(--cmd-bg);
}

.content-commande tbody td:nth-child(3) strong {
  font-family: var(--font-mono);
  font-size: 0.82rem;
}

.inputqtecommande {
  width: 72px !important;
  margin-bottom: 0 !important;
  text-align: center;
  padding: 7px 8px !important;
}

/* -------------------------------------------------------------------------
   Delivery picker (Validation step)
   ---------------------------------------------------------------------- */

.delivery-picker {
  margin: 20px 0;
  background: var(--cmd-bg);
  border-radius: var(--cmd-radius);
  padding: 20px;
  border: 1px solid var(--cmd-border);
}

.delivery-picker-label {
  font-size: 0.72rem;
  font-weight: 700;
  color: var(--cmd-light);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 12px;
}

.delivery-options {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 12px;
}

.delivery-option {
  border: 1.5px solid var(--cmd-border);
  border-radius: 14px;
  padding: 14px 12px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 500;
  color: var(--cmd-muted);
  background: var(--cmd-surface);
  transition: all 0.2s ease;
  text-align: center;
  min-height: 80px;
  justify-content: center;
}

.delivery-option.selected {
  border-color: var(--cmd-gold);
  font-weight: 600;
  color: var(--cmd-gold-ink);
  background: linear-gradient(145deg, var(--cmd-gold-dim), #fff1c2);
  box-shadow: 0 8px 24px rgba(255, 196, 0, 0.28);
}

.delivery-option i {
  font-size: 1.3rem;
}

.delivery-sublabel {
  font-size: 11.5px;
  font-weight: 600;
  color: var(--cmd-light);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 10px;
}

.delivery-empty {
  color: var(--cmd-light);
  text-align: center;
  padding: 16px;
}

.delivery-item {
  display: flex;
  align-items: flex-start;
  gap: 11px;
  border: 1.5px solid var(--cmd-border);
  border-radius: 14px;
  padding: 11px 13px;
  cursor: pointer;
  margin-bottom: 8px;
  background: var(--cmd-surface);
  transition: all 0.2s ease;
}

.delivery-item.selected {
  border-color: var(--cmd-gold);
  background: linear-gradient(135deg, var(--cmd-gold-dim), #fff1c2);
  box-shadow: 0 6px 20px rgba(255, 196, 0, 0.22);
}

.delivery-item-radio {
  width: 17px;
  height: 17px;
  border-radius: 50%;
  flex-shrink: 0;
  margin-top: 1px;
  border: 2px solid var(--cmd-border-strong);
  background: var(--cmd-surface);
}

.delivery-item.selected .delivery-item-radio {
  border-color: var(--cmd-gold);
  background: var(--cmd-gold);
  box-shadow: inset 0 0 0 3.5px white, 0 0 0 1px var(--cmd-gold);
}

.delivery-item-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--cmd-ink);
}

.delivery-item-title i {
  color: var(--cmd-gold-dark);
  margin-right: 4px;
}

.delivery-item-sub {
  font-size: 11px;
  color: var(--cmd-muted);
  margin-top: 3px;
}

.delivery-item-price {
  font-size: 10.5px;
  color: var(--cmd-light);
  margin-top: 3px;
}

.delivery-note {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 12px;
  font-weight: 500;
  padding: 10px 13px;
  border-radius: 12px;
  margin-top: 12px;
}

.delivery-note.blue {
  background: var(--cmd-blue-dim);
  color: var(--cmd-blue);
  border: 1px solid #bfdbfe;
}

.delivery-note.green {
  background: var(--cmd-success-dim);
  color: var(--cmd-success);
  border: 1px solid #bbf7d0;
}

/* -------------------------------------------------------------------------
   Order total summary
   ---------------------------------------------------------------------- */

.frais-summary {
  background: var(--cmd-bg);
  border-radius: var(--cmd-radius-sm);
  padding: 16px 20px;
  border: 1px solid var(--cmd-border);
  margin-bottom: 16px;
}

.frais-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  font-size: 0.95rem;
  color: var(--cmd-muted);
}

.frais-row strong {
  color: var(--cmd-ink-soft);
}

.frais-row.frais-livraison {
  color: var(--cmd-blue);
  font-weight: 500;
}

.frais-divider {
  height: 2px;
  background: linear-gradient(90deg, transparent, var(--cmd-border), transparent);
  margin: 8px 0;
}

.frais-total {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--cmd-ink);
}

.btns-valide-commande {
  display: flex;
  justify-content: flex-end;
}

/* -------------------------------------------------------------------------
   Responsive
   ---------------------------------------------------------------------- */

@media (max-width: 900px) {
  .container.commande-parent {
    grid-template-columns: 1fr;
  }

  .barleft-commande {
    position: static;
  }

  .barleft-commande ul {
    flex-direction: row;
    overflow-x: auto;
  }

  .barleft-commande button {
    border-left: none;
    border-bottom: 3px solid transparent;
    white-space: nowrap;
  }

  .barleft-commande button.active {
    border-bottom-color: var(--cmd-gold);
  }
}

/* -------------------------------------------------------------------------
   Accessibility
   ---------------------------------------------------------------------- */

.commande-container button:focus-visible,
.content-commande button:focus-visible,
.commande-container input:focus-visible,
.content-commande input:focus-visible,
.delivery-option:focus-visible,
.delivery-item:focus-visible {
  outline: 2px solid var(--cmd-blue);
  outline-offset: 2px;
}

@media (prefers-reduced-motion: reduce) {
  * {
    transition: none !important;
    animation: none !important;
  }
}
`;

export interface ProductTypeMagasins {
  magasins: ClientInfo[];
  messageErrosMagasin: string;
}

const EspaceCommande = () => {
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState("informations-client");
  const [nomClient, setNomClient] = useState(() => {
    const p = new URLSearchParams(window.location.search);
    return p.get('client') || '';
  });
  const [adresse, setAdresse] = useState(() => {
    const p = new URLSearchParams(window.location.search);
    return p.get('adresse') || '';
  });

  const [Phone, setPhone] = useState<any>('');
  const [Remarque, setRemarque] = useState<any>();
  const [Erreur, setErreur] = useState("");
  
  const MagasinId = localStorage.getItem('MagasinId');
  const MagasinName = localStorage.getItem('MagasinName');
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({ Remise: 0, TauxRemise: 0, MontantRemise: 0, IdArticle: 0, refArticle: "", quantity: 0, PrixNetHT: 0, designation: '', id: 0 });
  const [DataTable, setDataTable] = useState<any>([]);
  const [selectedDesignation, setSelectedDesignation] = useState('');

  const [sousClient, setSousClient] = useState("");
  const [states, setStates] = useState<ProductTypeMagasins>({
    magasins: [],
    messageErrosMagasin: "Il n'y a pas de magasin",
  });

  const DeleteColumn = (idToDelete: number) => {
    setDataTable((prevData: any[]) => prevData.filter((item: any) => item.id !== idToDelete));
  };

  const changeqte = (id: number, newqte: string) => {
    const index = DataTable.findIndex((item: { id: number }) => item.id === id);
    if (index !== -1) {
      const updatedItem = { ...DataTable[index], quantity: newqte };
      const updatedDataTable = [...DataTable.slice(0, index), updatedItem, ...DataTable.slice(index + 1)];
      setDataTable(updatedDataTable);
    }
  };

  const UpdateCommande = (id: number) => {
    const iconInput = document.querySelector<HTMLElement>(`.iconinputqtecommande[data-id="${id}"]`);
    if (iconInput) {
      iconInput.style.display = iconInput.style.display === 'none' ? 'block' : 'none';
    }
  };

  const AddArticleInTable = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_PHP_APP_URL}/articles/${data.refArticle && data.refArticle.includes(" ") ? data.refArticle.split(" ")[0] : data.refArticle}`);
      const newData2 = {
        Remise: response.data.Remise,
        TauxRemise: response.data.TauxRemise,
        MontantRemise: response.data.MontantRemise,
        IdArticle: data.IdArticle,
        refArticle: data.refArticle,
        quantity: data.quantity,
        prix: data.PrixNetHT,
        designation: data.designation,
        id: DataTable.length + 2
      };
      setDataTable((prevDataTable: any) => [...prevDataTable, newData2]);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  // ------------------------------ desktop ----------------------------------------

  const [step, setStep] = useState(1);
  const [screenWidth, setScreenWidth] = useState<number>(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const nextStep = () => setStep((prev) => prev + 1);
  const prevStep = () => setStep((prev) => prev - 1);

  const { magasins } = states;
  useEffect(() => {
    setLoading(true);
    AfficheClient(MagasinId)
      .GetClient()
      .then((res) => {
        setStates((prev) => ({ ...prev, magasins: res.data }));
        setLoading(false);
      })
      .catch((err) => {
        setStates((prev) => ({
          ...prev,
          messageErrosMagasin: err.messageErrosMagasin,
        }));
        setLoading(false);
      });
  }, []);

  const validateInformation = (): boolean => {
    if (!nomClient.trim()) {
      setErreur("Veuillez entrer le nom client.");
      setTimeout(() => setErreur(""), 3000);
      return false;
    }

    if (sousClient.trim() && !adresse.trim()) {
      setErreur("Veuillez entrer l'adresse.");
      setTimeout(() => setErreur(""), 3000);
      return false;
    }
    return true;
  };

  const [Refs, setRef] = useState<any[]>([]);
  const [search, setSearche] = useState("");
  const handleItemClick = (Remise: number, TauxRemise: number, MontantRemise: number, IdArticle: number, refArticle: any, designation: any, PrixNetHT: number) => {
    setData({ ...data, IdArticle, Remise, TauxRemise, MontantRemise, refArticle, designation, PrixNetHT });
    setSearche('');
  };

  const getRef = async (searchTerm: string) => {
    try {
      if (searchTerm.trim() === "") {
        return [];
      }
      const response = await axios.get(
        `${process.env.REACT_APP_PHP_APP_URL}/search-articles`,
        { params: { q: searchTerm } }
      );
      setRef(response.data.data);
      return response.data;
    } catch (error) {
      console.error("Error:", error);
      return [];
    }
  };

  const triggerSearchMobile = async () => {
    const value = search.trim();
    if (value === "") { setRef([]); return; }
    await getRef(value);
  };
  const handleSearchKeyDownMobile = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") triggerSearchMobile();
  };

  const styles = StyleSheet.create({
    containerTest: { padding: 30, fontFamily: 'Helvetica' },
    headerContainer: { flexDirection: 'row', justifyContent: 'space-between', marginBottom: 20, borderBottomWidth: 1, borderBottomColor: '#e2e8f0', paddingBottom: 15 },
    bdcTitle: { fontSize: 20, fontWeight: 'bold', color: '#1e293b' },
    infoMagas: { fontSize: 8, color: '#64748b', textAlign: 'right' },
    infoClient: { borderWidth: 1, borderColor: '#cbd5e1', borderRadius: 8, padding: 12, marginBottom: 25, width: '50%' },
    infoClientTitle: { fontSize: 10, fontWeight: 'bold', color: '#475569', marginBottom: 4 },
    text: { fontSize: 9, color: '#334155', marginBottom: 2 },
    title: { fontSize: 13, fontWeight: 'bold', color: '#1e293b', marginBottom: 10 },
    table: { borderWidth: 1, borderColor: '#cbd5e1', borderRadius: 6, overflow: 'hidden' },
    tableRowHeader: { flexDirection: 'row', backgroundColor: '#f1f5f9', borderBottomWidth: 1, borderBottomColor: '#cbd5e1', padding: 6 },
    tableRow: { flexDirection: 'row', borderBottomWidth: 1, borderBottomColor: '#e2e8f0', padding: 6 },
    tableCellHeader: { fontSize: 9, fontWeight: 'bold', color: '#475569' },
    tableCell: { fontSize: 9, color: '#334155' },
    colRef: { width: '25%' },
    colDes: { width: '40%' },
    colPrix: { width: '15%', textAlign: 'right' },
    colNet: { width: '10%' },
    colQte: { width: '10%', textAlign: 'right' },
  });

  const groupedByMagasin = DataTable.reduce((acc: any, item: any) => {
    const magasin = item.NomMagasin || 'Inconnu';
    if (!acc[magasin]) acc[magasin] = [];
    acc[magasin].push(item);
    return acc;
  }, {});

  const PdfDocumentByMagasin = ({ magasin, articles }: { magasin: string, articles: any[] }) => (
    <Document>
      <Page style={styles.containerTest} size="A4">
        {/* Header section with Bon de commande & Info Magasin */}
        <View style={styles.headerContainer}>
          <View>
            <Text style={styles.bdcTitle}>Bon de commande</Text>
            <Text style={{ fontSize: 10, color: '#64748b', marginTop: 4 }}>Magasin : {magasin}</Text>
          </View>
          <View style={styles.infoMagas}>
            <Text>Siège : 684 Bd de la grande hay mohammadi, casablanca, maroc</Text>
            <Text>Fax : 05 22 60 90 85</Text>
            <Text>Site Web : www.pagec.ma</Text>
          </View>
        </View>

        {/* Client Info */}
        <View style={styles.infoClient}>
          <Text style={styles.infoClientTitle}>DÉTAILS CLIENT</Text>
          <Text style={styles.text}>Nom client : {nomClient}</Text>
          <Text style={styles.text}>Adresse : {adresse || 'Non spécifiée'}</Text>

        </View>

        {/* Articles Table */}
        <Text style={styles.title}>Liste des Articles</Text>
        <View style={styles.table}>
          {/* Table Header */}
          <View style={styles.tableRowHeader}>
            <View style={styles.colRef}><Text style={styles.tableCellHeader}>Ref. Article</Text></View>
            <View style={styles.colDes}><Text style={styles.tableCellHeader}>Désignation</Text></View>
            <View style={styles.colPrix}><Text style={[styles.tableCellHeader, { textAlign: 'right' }]}>Prix HT</Text></View>
            <View style={styles.colNet}><Text style={styles.tableCellHeader}></Text></View>
            <View style={styles.colQte}><Text style={[styles.tableCellHeader, { textAlign: 'right' }]}>Qté</Text></View>
          </View>
          
          {/* Table Body */}
          {articles.map((ref: any, index: number) => (
            <View key={index} style={styles.tableRow}>
              <View style={styles.colRef}><Text style={styles.tableCell}>{ref.refArticle || 'null'}</Text></View>
              <View style={styles.colDes}><Text style={styles.tableCell}>{ref.designation || 'null'}</Text></View>
              <View style={styles.colPrix}><Text style={[styles.tableCell, { textAlign: 'right' }]}>{parseFloat(ref.prix || 0).toFixed(2)} MAD</Text></View>
              <View style={styles.colNet}><Text style={styles.tableCell}></Text></View>
              <View style={styles.colQte}><Text style={[styles.tableCell, { textAlign: 'right' }]}>{ref.quantity || 0}</Text></View>
            </View>
          ))}
        </View>
      </Page>
    </Document>
  );

  const calculeTotal = () => {
    return DataTable.reduce((total: number, ref: { prix: string; quantity: number; }) => total + (ref.prix ? parseFloat(ref.prix) * ref.quantity : 0), 0);
  };

  const [showSuccessPopup, setShowSuccessPopup] = useState<boolean>(false);
  const params = new URLSearchParams(window.location.search);
  const idClient = params.get("idVisiteur");
  const clientName = params.get("client");

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("adress", adresse);

    formData.append("NomClient", nomClient);
    formData.append("SousClient", sousClient);
    formData.append("Remarque", Remarque);
    formData.append("TotalHT", calculeTotal().toString());
    formData.append("NomMagasin", MagasinName || "");
    formData.append("IdMagasin", MagasinId || "");
    formData.append("TypeUtilisateur", localStorage.getItem('CommercialId') ? 'commercial' : localStorage.getItem('ClientId') ? 'client' : localStorage.getItem('VisiteurId') ? 'visiteur' : 'magasin');

    DataTable.forEach((item: Record<string, any>, index: number) => {
      for (const key in item) {
        if (Object.prototype.hasOwnProperty.call(item, key)) {
          formData.append(`detail[${index}][${key}]`, String(item[key]));
        }
      }
    });

    if (!DataTable.length) return setErreur("Veuillez entrer les informations des articles.");
    if (sousClient.trim() && !adresse.trim()) return setErreur("Veuillez entrer l'adresse.");

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_PHP_APP_URL}/enregistrerCommande`,
        formData
      );

      const commandeId = response.data;
      console.log("idcomaande", commandeId);

      await axios.post(
        `${process.env.REACT_APP_PHP_APP_URL}/sendArticleCommande/${response.data.IdBl}`,
        { DataTable },
        { headers: { "Content-Type": "application/json" } }
      );

      setLoading(true);
      setShowSuccessPopup(true);

      const timeoutId = setTimeout(() => {
        setShowSuccessPopup(false);
        navigate(`/magasins/${MagasinId}/historiques`);
      }, 2000);

      return () => clearTimeout(timeoutId);
    } catch (error: any) {
      console.error("Erreur lors de l'envoi de la commande:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleGoBacks = () => {
    if (step > 1) {
      setStep(step - 1);
    }
  };

  const AddListArticle = async () => {
    const input = data.refArticle;
    if (!input) return;

    const lines = input.split("\n");
    const newDataTable: typeof DataTable = [];

    for (const line of lines) {
      let qty = "1";
      let ref = "";

      const separatorRegex = /,|\s{2,}/;

      if (separatorRegex.test(line)) {
        const parts = line.split(separatorRegex);
        if (parts.length >= 2) {
          ref = parts[0].trim();
          qty = parts[1].trim();
        } else {
          console.error(`Format invalide: "${line}"`);
          continue;
        }
      } else {
        console.error(`Format invalide: "${line}"`);
        continue;
      }

      const formattedRef = ref.toUpperCase();
      if (!formattedRef || !qty) continue;

      const cleanedFormattedRef = formattedRef.replace(/[-_.*\/?\\\s]/g, '');
      const foundArticles = await getRef(cleanedFormattedRef);

      if (!foundArticles || foundArticles.length === 0) {
        console.error(`Référence introuvable : "${formattedRef}"`);
        continue;
      }

      for (const selectedArticle of foundArticles) {
        const existingIndex = DataTable.findIndex(
          (row: { refArticle: string; NomMagasin: any }) =>
            row.refArticle.trim().toUpperCase() === selectedArticle.RefArticle.trim().toUpperCase() &&
            row.NomMagasin === selectedArticle.NomMagasin
        );

        if (existingIndex !== -1) {
          const updatedTable: any = [...DataTable];
          updatedTable[existingIndex].quantity = (
            parseInt(updatedTable[existingIndex].quantity) + parseInt(qty)
          ).toString();
          setDataTable(updatedTable);
          continue;
        }

        const newIndex = newDataTable.findIndex(
          (row: { refArticle: string; NomMagasin: any }) =>
            row.refArticle.trim().toUpperCase() === selectedArticle.RefArticle.trim().toUpperCase() &&
            row.NomMagasin === selectedArticle.NomMagasin
        );

        if (newIndex !== -1) {
          newDataTable[newIndex].quantity = (
            parseInt(newDataTable[newIndex].quantity) + parseInt(qty)
          ).toString();
        } else {
          newDataTable.push({
            Remise: selectedArticle.Remise,
            TauxRemise: selectedArticle.TauxRemise,
            MontantRemise: selectedArticle.MontantRemise,
            IdArticle: selectedArticle.IdArticle,
            refArticle: selectedArticle.RefArticle,
            quantity: qty,
            Quantité: selectedArticle.Quantité,
            prix: selectedArticle.PrixNetHT,
            NomMagasin: selectedArticle.NomMagasin,
            designation: selectedArticle.Designation,
            id: DataTable.length + newDataTable.length + 1,
          });
        }
      }
    }

    if (newDataTable.length > 0) {
      setDataTable((prev: any) => [...prev, ...newDataTable]);
    }

    setData({ ...data, refArticle: "", quantity: 0 });
    setLoading(false);
  };

  if (screenWidth <= 450) {
    return (
      <>
        <style>{commandeStyles}</style>
        <SideBareMagasin />
        <div className="commande-container">
          <div className="barRetour mb-3">
            <span className="iconRetour" onClick={handleGoBacks}>
              <i className="bi bi-arrow-left-short"></i>
            </span>
          </div>

          <div className="step-header">
            <div className={`step ${step === 1 ? "active" : ""}`}>Information</div>
            <div className={`step ${step === 2 ? "active" : ""}`}>Articles</div>
            <div className={`step ${step === 3 ? "active" : ""}`}>Confirmation</div>
          </div>

          <div className="form-section mb-5">
            {loading ? (
              <div className="d-flex justify-content-center align-items-center" style={{ height: '280px' }}>
                <div className="spinner-border custom-spinner" role="status"></div>
                <span className="loader-charg">Chargement</span>
              </div>
            ) : (
              <>
                {step === 1 && (
                  <div>
                    <h2 className="mb-4">Informations personnelles</h2>
                    {Erreur !== "" && (
                      <div className="alert alert-danger" role="alert">
                        <strong><i className="bi bi-exclamation-triangle"></i> {Erreur}</strong>
                      </div>
                    )}

                    <span className="mb-2">Client</span>
                    <select
                      name="fullName"
                      className="custom-select mb-4"
                      onChange={(e) => {
                        const selectedName = e.target.value;
                        const selectedMag = magasins.find(mag => mag.NomClient === selectedName);

                        setNomClient(selectedName);
                        if (selectedMag && sousClient.trim() === "") {
                          setAdresse(selectedMag.Adresse);
                        }
                      }}
                    >
                      {magasins.map((mag) => (
                        <option key={mag.NomClient} value={mag.NomClient}>
                          {mag.NomClient}
                        </option>
                      ))}
                    </select>

                    <span className="mb-2">Sous Client</span>
                    <input type="text" />

                    <span className="mb-2">Adresse</span>
                    <input
                      type="text"
                      placeholder="adresse"
                      name="email"
                      className="mb-4"
                      value={adresse}
                      onChange={(e) => { setAdresse(e.target.value); }}
                    />

                    <span className="mb-2">Numéro téléphone</span>
                    <input
                      type="text"
                      placeholder="Personal website"
                      name="website"
                      className="mb-4"
                    />

                    <button
                      onClick={() => {
                        if (validateInformation()) {
                          nextStep();
                        }
                      }}
                    >
                      Continuer
                    </button>
                  </div>
                )}

                {step === 2 && (
                  <div>
                    <h2 className="mb-4">Recherche articles</h2>
                    <span>Référence article</span>

                    <input
                      type="text"
                      name="article"
                      className="mb-3"
                      value={selectedDesignation || data.refArticle}
                      onChange={(e) => {
                        setSearche(e.target.value);
                        setData({ ...data, refArticle: e.target.value, designation: "" });
                      }}
                      onKeyDown={handleSearchKeyDownMobile}
                      placeholder="Tapez une référence puis appuyez Entrée"
                    />
                    <button
                      type="button"
                      style={{ marginBottom: '12px' }}
                      onClick={triggerSearchMobile}
                    >
                      <i className="bi bi-search"></i> Rechercher
                    </button>

                    {Refs.length > 0 && (
                      <div className="resultsref">
                        {Refs.filter((ref) => {
                          const refArticle = ref.RefArticle.toString().toLowerCase();
                          return refArticle.startsWith(search.toLowerCase());
                        }).map((filteredRef) => (
                          <span
                            className="resultref"
                            key={filteredRef.id}
                            onClick={() =>
                              handleItemClick(
                                filteredRef.Remise,
                                filteredRef.TauxRemise,
                                filteredRef.MontantRemise,
                                filteredRef.IdArticle,
                                filteredRef.RefArticle,
                                filteredRef.Designation,
                                filteredRef.PrixNetHT
                              )
                            }
                          >
                            {filteredRef.Designation} — {filteredRef.RefArticle}
                          </span>
                        ))}
                      </div>
                    )}

                    <span className="mt-3">Quantité</span>
                    <div className="quantity-container">
                      <input
                        type="number"
                        name="quantity"
                        min={1}
                        value={data.quantity}
                        onChange={(e) =>
                          setData({ ...data, quantity: Number(e.target.value) })
                        }
                      />
                    </div>

                    <div className="mt-2 mb-5">
                      <span className="mt-3">Ajouter une liste de produits</span>
                      <textarea
                        className="form-control"
                        value={data.refArticle}
                        onChange={(e) => setData({ ...data, refArticle: e.target.value })}
                        placeholder={`Copiez et collez les numéros de pièce et les quantités correspondantes dans la zone à gauche.
Vous pouvez séparer la quantité et le numéro de pièce par une virgule ou une tabulation, mais placez toujours la quantité en premier et virgule tabulation suivie du numéro de pièce. Par exemple :
6, 2P4004
2  9NS924

Vous pouvez également copier et coller une liste préparée dans Excel. Si vous saisissez uniquement le numéro de pièce ou si la quantité est incorrecte, la quantité sera supposée être un (1).

N'incluez pas de caractères spéciaux dans le numéro de pièce, sauf s'ils en font partie, sinon ils ne seront pas reconnus.`}
                        id="exampleFormControlTextarea1"
                        rows={6}
                      ></textarea>
                    </div>

                    <div className="buttons">
                      <button
                        onClick={() => {
                          if (data.refArticle && data.quantity) {
                            nextStep();
                          } else {
                            AddListArticle();
                            nextStep();
                          }
                        }}
                      >
                        Continuer
                      </button>
                    </div>
                  </div>
                )}

                {step === 3 && (
                  <div>
                    {showSuccessPopup && (
                      <div className="popup-success">
                        <div className="popup-content">
                          <div className="popup-icon">
                            <i className="bi bi-check-circle-fill"></i>
                          </div>
                          <h5>Votre commande a été effectuée avec succès</h5>
                          <p>Veuillez attendre 24h <i className="bi bi-clock-history"></i></p>
                        </div>
                      </div>
                    )}
                    <h2>Résumé de la commande</h2>
                    <p>Vérifiez les détails des articles ajoutés :</p>

                    <div className="article-list">
                      {DataTable.length > 0 ? (
                        DataTable.map((article: any, index: number) => (
                          <div key={index} className="article-card">
                            <i
                              className="bi bi-trash btn-delete-commande-mobile"
                              onClick={() =>
                                setDataTable((prev: any) => prev.filter((_: any, i: number) => i !== index))
                              }
                            ></i>

                            <div><span className="ref-tag">{article.refArticle}</span></div>
                            <div><strong>Désignation</strong>{article.designation}</div>
                            <div><strong>Prix HT</strong>{article.prix} MAD</div>
                            <div><strong>Qté</strong>{article.quantity}</div>
                            <div>
                              <strong>Montant HT</strong>
                              {parseFloat(article.prix) * parseInt(article.quantity)} MAD
                            </div>
                          </div>
                        ))
                      ) : data.refArticle && data.quantity ? (
                        <div key={data.id} className="article-card">
                          <i className="bi bi-trash btn-delete-commande-mobile"></i>
                          <div><span className="ref-tag">{data.refArticle}</span></div>
                          <div><strong>Désignation</strong>{data.designation}</div>
                          <div><strong>Prix HT</strong>{data.PrixNetHT} MAD</div>
                          <div><strong>Qté</strong>{data.quantity}</div>
                          <div>
                            <strong>Montant HT</strong>
                            {data.PrixNetHT * data.quantity} MAD
                          </div>
                        </div>
                      ) : (
                        <p style={{ color: 'var(--cmd-danger)', textAlign: 'center', marginTop: '5%', padding: '1rem 0', fontSize: '1.05rem' }}>
                          <i className="bi bi-question-circle"></i> Aucun article ajouté à la commande
                        </p>
                      )}
                    </div>

                    <div className="commande-actions">
                      <Link className="Vb-mobile" onClick={handleSubmit} to={""}>
                        Valider
                      </Link>
                    </div>

                    {(Object.entries(groupedByMagasin) as [string, any[]][]).map(([magasin, articles]) => (
                      <div key={magasin} className="mb-3">
                        <PDFDownloadLink
                          document={<PdfDocumentByMagasin magasin={magasin} articles={articles} />}
                          fileName={`bon_de_commande_${magasin}.pdf`}
                          style={{ textDecoration: "none" }}
                        >
                          {({ loading }) => (
                            <button className="btn tbd-mobile">
                              <i className="bi bi-cloud-download"></i> {loading ? "Chargement..." : `Télécharger PDF - ${magasin}`}
                            </button>
                          )}
                        </PDFDownloadLink>
                      </div>
                    ))}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <style>{commandeStyles}</style>
      <NewSideBarMagasins />
      {loading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ height: "550px" }}>
          <div className="spinner-border custom-spinner" role="status"></div>
          <span className="loader-charg">Chargement</span>
        </div>
      ) : (
        <>
          <h2 className="btn-bienvenu-espace-commande">Bienvenue sur votre espace</h2>
          <div className="container commande-parent">
            <aside className="barleft-commande">
              <nav>
                <ul>
                  <li>
                    <button
                      className={activeSection === "informations-client" ? "active" : ""}
                      onClick={() => setActiveSection("informations-client")}
                    >
                      <i className="bi bi-person-badge" style={{ marginRight: 8 }}></i>Informations client
                    </button>
                  </li>
                  <li>
                    <button
                      className={activeSection === "recherche-article" ? "active" : ""}
                      onClick={() => setActiveSection("recherche-article")}
                    >
                      <i className="bi bi-search" style={{ marginRight: 8 }}></i>Recherche article
                    </button>
                  </li>
                  <li>
                    <button
                      className={activeSection === "listes-articles" ? "active" : ""}
                      onClick={() => setActiveSection("listes-articles")}
                    >
                      <i className="bi bi-list-ul" style={{ marginRight: 8 }}></i>Liste des articles
                    </button>
                  </li>
                  <li>
                    <button
                      className={activeSection === "Validation" ? "active" : ""}
                      onClick={() => setActiveSection("Validation")}
                    >
                      <i className="bi bi-check2-circle" style={{ marginRight: 8 }}></i>Validation
                    </button>
                  </li>
                </ul>
              </nav>
            </aside>

            <main className="content-commande">
              {activeSection === "informations-client" && (
                <InformationsClient
                  nomClient={nomClient}
                  setNomClient={setNomClient}
                  Phone={Phone}
                  setPhone={setPhone}
                  sousClient={sousClient}
                  setSousClient={setSousClient}
                  adresse={adresse}
                  setAdresse={setAdresse}

                />
              )}
              {activeSection === "recherche-article" && (
                <RechercheArticle DataTable={DataTable} setDataTable={setDataTable} setActiveSection={setActiveSection} />
              )}
              {activeSection === "listes-articles" && (
                <ListesArticles setActiveSection={setActiveSection} DataTable={DataTable} setDataTable={setDataTable} />
              )}
              {activeSection === "Validation" && (
                <Validation nomClient={nomClient} sousClient={sousClient} adresse={adresse} DataTable={DataTable} />
              )}
            </main>
          </div>
        </>
      )}
    </>
  );
};

// ---------------------------------------------------------------------------
// InformationsClient
// ---------------------------------------------------------------------------

interface InformationsClientProps {
  nomClient: string;
  Phone: number;
  setPhone: (value: any) => void;
  setNomClient: (value: string) => void;
  sousClient: string;
  setSousClient: (value: string) => void;
  adresse: string;
  setAdresse: (value: string) => void;

}

const InformationsClient: React.FC<InformationsClientProps> = ({
  nomClient, setNomClient, sousClient, setSousClient, adresse, setAdresse, setPhone, Phone
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [states, setStates] = useState<ProductTypeMagasins>({
    magasins: [],
    messageErrosMagasin: "Il n'y a pas de magasin",
  });
  const AdresseDefault = localStorage.getItem('adresse');
  const MagasinName = localStorage.getItem('MagasinName');
  const IdMagasin = localStorage.getItem('MagasinId');

  const { magasins } = states;
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    AfficheClient(IdMagasin)
      .GetClient()
      .then((res) => {
        setStates((prev) => ({ ...prev, magasins: res.data }));
        
        // Set the client's address if it's not already set
        if (nomClient && !adresse) {
          const clientData = res.data.find((mag: any) => mag.NomClient === nomClient);
          if (clientData) {
            setAdresse(clientData.Adresse);
          }
        }
        
        setLoading(false);
      })
      .catch((err) => {
        setStates((prev) => ({
          ...prev,
          messageErrosMagasin: err.messageErrosMagasin,
        }));
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    if (!nomClient && MagasinName) {
      setNomClient(MagasinName);
      if (!adresse) {
        setAdresse(AdresseDefault ? AdresseDefault : "");
      }
    } else if (nomClient === MagasinName && !adresse) {
      setAdresse(AdresseDefault ? AdresseDefault : "");
    }
  }, [MagasinName, nomClient, adresse, AdresseDefault]);

  return (
    <section>
      <div className="header-information-client">
        <h3>Informations client</h3>
        <button onClick={() => setIsEditing(!isEditing)} className="edit-btn-commande">
          {isEditing ? "Enregistrer" : "Modifier"} <i className="bi bi-pencil-square"></i>
        </button>
      </div>

      {loading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ height: "250px" }}>
          <div className="spinner-border custom-spinner" role="status"></div>
          <span className="loader-charg">Chargement</span>
        </div>
      ) : (
        <div className="info-card">
          <div className="row">
            <div className="col">
              <label>Nom client</label>
              <select
                className="form-control"
                disabled={!isEditing}
                value={nomClient}
                onChange={(e) => {
                  const selectedName = e.target.value;
                  const selectedMag = magasins.find(mag => mag.NomClient === selectedName);

                  setNomClient(selectedName);
                  if (selectedMag && sousClient.trim() === "") {
                    setAdresse(selectedMag.Adresse);
                  }
                }}
              >
                <option value="">{nomClient ? nomClient : "-- Sélectionner un magasin --"}</option>
                {magasins.map((mag) => (
                  <option key={mag.NomClient} value={mag.NomClient}>
                    {mag.NomClient}
                  </option>
                ))}
              </select>
            </div>
            <div className="col">
              <label>Sous client</label>
              <input
                value={sousClient}
                onChange={(e) => {
                  const value = e.target.value;
                  setSousClient(value);

                  if (value.trim() !== "") {
                    setAdresse("");
                  } else {
                    const selectedMag = magasins.find(mag => mag.NomClient === nomClient);
                    if (selectedMag) {
                      setAdresse(selectedMag.Adresse);
                    }
                  }
                }}
                disabled={!isEditing}
                type="text"
                className="form-control"
                placeholder="sous client"
                aria-label="sous client"
              />
            </div>
          </div>
          <div className="row mt-3">
            <div className="col">
              <label>Numéro téléphone</label>
              <input
                value={Phone}
                disabled={!isEditing}
                type="text"
                className="form-control"
                placeholder="Phone Number"
                aria-label="Phone Number"
                onChange={(e) => setPhone(e.target.value)}
              />
            </div>

            <div className="col">
              <label>Email</label>
              <input
                disabled={!isEditing}
                type="text"
                className="form-control"
                placeholder="Email"
                aria-label="Email"
              />
            </div>
            <div className="col-12 mt-3">
              <label htmlFor="inputAddress2" className="form-label">Adresse</label>
              <input
                value={adresse}
                onChange={(e) => {
                  if (sousClient.trim() !== "") {
                    setAdresse(e.target.value);
                  }
                }}
                disabled={!isEditing}
                type="text"
                className="form-control"
                id="inputAddress"
                placeholder="1234 Main St"
              />
            </div>

          </div>
        </div>
      )}
    </section>
  );
};

// ---------------------------------------------------------------------------
// RechercheArticle
// ---------------------------------------------------------------------------

interface ListesArticlesProps {
  DataTable: any[];
  setDataTable: React.Dispatch<React.SetStateAction<any[]>>;
  setActiveSection: (value: string) => void;
}

const RechercheArticle: React.FC<ListesArticlesProps> = ({ DataTable, setDataTable, setActiveSection }) => {
  const [data, setData] = useState({ Remise: 0, TauxRemise: 0, MontantRemise: 0, IdArticle: 0, refArticle: "", Quantité: 0, quantity: "", PrixNetHT: 0, designation: '', NomMagasin: "", id: 0 });
  const [Refs, setRef] = useState<any[]>([]);

  const [loading, setLoading] = useState(false);
  const [messageSucess, setMessageSucess] = useState("");
  const [messageError, setMessageError] = useState("");
  const [search, setSearch] = useState("");

  const handleItemClick = (Remise: number, TauxRemise: number, MontantRemise: number, IdArticle: number, refArticle: any, designation: any, Quantité: number, PrixNetHT: number, NomMagasin: any) => {
    setData({ ...data, IdArticle, Remise, TauxRemise, MontantRemise, refArticle, designation, Quantité, PrixNetHT, NomMagasin });
    setSearch('');
    setRef([]);
  };

  const AddArticleInTable = async () => {
    setLoading(true);
    const input = data.refArticle.trim();

    if (!input) {
      setMessageError("Le champ Reference doit être renseigné");
      setLoading(false);
      return;
    }
    if (!data.quantity) {
      setMessageError("Le champ Quantité doit être renseigné");
      setLoading(false);
      return;
    }

    try {
      const response = await axios.get(`${process.env.REACT_APP_PHP_APP_URL}/articles/${input}`);
      const articleData = response.data;

      const existingIndex = DataTable.findIndex(
        row =>
          row.refArticle.toUpperCase() === input.toUpperCase() &&
          row.nomMagasin === data.NomMagasin
      );

      if (existingIndex !== -1) {
        const updatedTable = [...DataTable];
        updatedTable[existingIndex].quantity = (
          parseInt(updatedTable[existingIndex].quantity) + parseInt(data.quantity)
        ).toString();
        setDataTable(updatedTable);
      } else {
        const newData = {
          Remise: articleData.Remise,
          TauxRemise: articleData.TauxRemise,
          MontantRemise: articleData.MontantRemise,
          IdArticle: data.IdArticle,
          refArticle: input.toUpperCase(),
          quantity: data.quantity,
          Quantité: data.Quantité,
          prix: data.PrixNetHT,
          NomMagasin: data.NomMagasin,
          designation: data.designation,
          id: DataTable.length + 1,
        };
        setDataTable((prev) => [...prev, newData]);
      }

      setData({ ...data, refArticle: "", quantity: "" });
      setMessageSucess("Votre commande a été bien envoyée");
      setTimeout(() => {
        setMessageSucess("");
        setActiveSection("listes-articles");
      }, 2000);
      setLoading(false);
    } catch (error) {
      console.error('Erreur:', error);
    }
  };

  const AddListArticle = async () => {
    const input = data.refArticle;
    if (!input || !input.trim()) {
      setMessageError("Veuillez saisir au moins une référence.");
      return;
    }

    setLoading(true);
    setMessageError("");
    const lines = input.split("\n").filter(l => l.trim() !== "");
    const newDataTable: typeof DataTable = [];
    const errors: string[] = [];

    for (const line of lines) {
      let qty = "1";
      let ref = "";

      const separatorRegex = /,|\t|\s{3,}/;

      if (separatorRegex.test(line)) {
        const parts = line.split(separatorRegex);
        ref = parts[0].trim();
        qty = parts.length >= 2 && parts[1].trim() ? parts[1].trim() : "1";
      } else {
        ref = line.trim();
        qty = "1";
      }

      if (!ref) continue;
      const formattedRef = ref.toUpperCase();

      try {
        const response = await axios.get(`${process.env.REACT_APP_PHP_APP_URL}/search-articles`, {
          params: { q: formattedRef },
        });
        const foundArticles = response.data.data;

        if (!foundArticles || foundArticles.length === 0) {
          errors.push(formattedRef);
          continue;
        }

        for (const selectedArticle of foundArticles) {
          const existingIndex = DataTable.findIndex(row =>
            row.refArticle.trim().toUpperCase() === selectedArticle.RefArticle.trim().toUpperCase() &&
            row.NomMagasin === selectedArticle.NomMagasin
          );

          if (existingIndex !== -1) {
            const updatedTable = [...DataTable];
            updatedTable[existingIndex].quantity = (
              parseInt(updatedTable[existingIndex].quantity) + parseInt(qty)
            ).toString();
            setDataTable(updatedTable);
            continue;
          }

          const newIndex = newDataTable.findIndex(row =>
            row.refArticle.trim().toUpperCase() === selectedArticle.RefArticle.trim().toUpperCase() &&
            row.NomMagasin === selectedArticle.NomMagasin
          );

          if (newIndex !== -1) {
            newDataTable[newIndex].quantity = (
              parseInt(newDataTable[newIndex].quantity) + parseInt(qty)
            ).toString();
          } else {
            newDataTable.push({
              Remise: selectedArticle.Remise,
              TauxRemise: selectedArticle.TauxRemise,
              MontantRemise: selectedArticle.MontantRemise,
              IdArticle: selectedArticle.IdArticle,
              refArticle: selectedArticle.RefArticle,
              quantity: qty,
              Quantité: selectedArticle.Quantité,
              prix: selectedArticle.PrixNetHT,
              NomMagasin: selectedArticle.NomMagasin,
              designation: selectedArticle.Designation,
              id: DataTable.length + newDataTable.length + 1,
            });
          }
        }
      } catch (error) {
        errors.push(formattedRef);
      }
    }

    if (newDataTable.length > 0) {
      setDataTable(prev => [...prev, ...newDataTable]);
    }

    setData({ ...data, refArticle: "", quantity: "" });

    if (errors.length > 0) {
      setMessageError(`Références introuvables : ${errors.join(", ")}`);
    }
    if (newDataTable.length > 0 || errors.length === 0) {
      setMessageSucess("Articles ajoutés avec succès.");
      setTimeout(() => {
        setMessageSucess("");
        setActiveSection("listes-articles");
      }, 2000);
    }
    setLoading(false);
  };

  const normalizeString = (str: string = "") =>
    str.replace(/[-_.*\/?\\\s]/g, "").toLowerCase();

  const getRef = async (searchTerm: string) => {
    try {
      if (searchTerm.trim() === "") {
        setRef([]);
        return;
      }
      const response = await axios.get(`${process.env.REACT_APP_PHP_APP_URL}/search-articles`, {
        params: { q: searchTerm },
      });
      setRef(response.data.data);
    } catch (error) {
      console.error('Error:', error);
    }
  };
  const triggerSearch = async () => {
    const value = search.trim();
    if (value === "") { setRef([]); return; }
    await getRef(value);
  };
  const handleSearchKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") triggerSearch();
  };

  const [selectedDesignation] = useState('');

  return (
    <section>
      <h3>Recherche article</h3>
      {loading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ height: "250px" }}>
          <div className="spinner-border custom-spinner" role="status"></div>
          <span className="loader-charg">Chargement</span>
        </div>
      ) : (
        <>
          <div className="row formec">
            {messageSucess && <div className="alert alert-success">{messageSucess}</div>}
            {messageError && <div className="alert alert-danger">{messageError}</div>}

            <div className="col-12 mt-3">
              <label htmlFor="inputAddress2" className="form-label">Référence article</label>
              <div style={{ display: 'flex', gap: '8px' }}>
                <input
                  onChange={(e) => {
                    setSearch(e.target.value);
                    setData({ ...data, refArticle: e.target.value, designation: "" });
                  }}
                  onKeyDown={handleSearchKeyDown}
                  value={selectedDesignation || data.refArticle}
                  type="text"
                  className="form-control"
                  id="inputAddress"
                  placeholder="Tapez une référence puis cliquez Rechercher"
                />
                <button
                  type="button"
                  className="btn-ajoute-interface-commande"
                  style={{ whiteSpace: 'nowrap', marginBottom: 0 }}
                  onClick={triggerSearch}
                >
                  <i className="bi bi-search"></i> Rechercher
                </button>
              </div>
            </div>

            {Refs.length > 0 && (
              <div className="resultsref">
                {Refs.filter(ref => {
                  const refArticle = normalizeString(ref.RefArticle.toString());
                  const normalizedSearch = normalizeString(search);
                  return refArticle.startsWith(normalizedSearch);
                }).map(filteredRef => (
                  <span
                    className="resultref"
                    key={filteredRef.id}
                    onClick={() =>
                      handleItemClick(
                        filteredRef.Remise,
                        filteredRef.TauxRemise,
                        filteredRef.MontantRemise,
                        filteredRef.IdArticle,
                        filteredRef.RefArticle,
                        filteredRef.Designation,
                        filteredRef.Quantité,
                        filteredRef.PrixNetHT,
                        filteredRef.NomMagasin
                      )
                    }
                  >
                    {filteredRef.Designation} — {filteredRef.RefArticle} — {filteredRef.PrixNetHT} MAD ({filteredRef.NomMagasin})
                  </span>
                ))}
              </div>
            )}

            <div className="col-12 mt-3">
              <label htmlFor="inputAddress2" className="form-label">Quantité</label>
              <input
                type="text"
                onChange={(e) => { setData({ ...data, quantity: e.target.value }); }}
                className="form-control"
                id="inputAddress"
              />
            </div>
          </div>

          <button className="btn-ajoute-interface-commande mb-5" onClick={AddArticleInTable}>Ajouter</button>

          <div className="row">
            <h4 className="mt-4">Ajouter une liste d'articles rapidement</h4>

            <div className="col-md-6 mb-3">
              <label htmlFor="textarea1" className="form-label">Saisir les références et quantités</label>
              <textarea
                className="form-control"
                value={data.refArticle}
                onChange={(e) => setData({ ...data, refArticle: e.target.value })}
                placeholder={"REF001   5\nREF002   3\nREF003   10"}
                id="textarea1"
                rows={10}
              ></textarea>
            </div>
            <div className="col-md-6 mb-3">
              <label htmlFor="textarea2" className="form-label">Instructions</label>
              <textarea
                className="form-control"
                id="textarea2"
                rows={10}
                readOnly
                value={`Format : Référence   Quantité (séparés par 3 espaces, une tabulation ou une virgule)

Exemple :
2P4004   6
9NS924   2
ABC123,4

➡️ Tapez la référence article
➡️ Appuyez sur Tab ou tapez 3 espaces minimum
➡️ Écrivez la quantité
➡️ Appuyez sur Entrée pour passer à la ligne suivante
➡️ Répétez autant de fois que nécessaire
➡️ Cliquez "Ajouter" pour valider

Si la quantité est omise, elle sera 1 par défaut.`}
              ></textarea>
            </div>
            <div className="d-flex justify-content-center">
              <button className="btn-ajoute-interface-commande mb-5" onClick={AddListArticle}>
                Ajouter
              </button>
            </div>
          </div>
        </>
      )}
    </section>
  );
};

// ---------------------------------------------------------------------------
// ListesArticles
// ---------------------------------------------------------------------------

const ListesArticles: React.FC<ListesArticlesProps> = ({ DataTable, setDataTable }) => {
  const [selectedRows, setSelectedRows] = React.useState<number[]>([]);
  const [errorQuantities, setErrorQuantities] = React.useState<any>({});

  const handleDeleteByCoche = (id: number) => {
    setDataTable(prev => prev.filter(article => article.id !== id));
    setSelectedRows(prev => prev.filter(selectedId => selectedId !== id));
  };

  const calcTotal = () => {
    return DataTable.reduce((sum, a) => {
      const price = parseFloat(String(a.prix).replace(',', '.')) || 0;
      const qty = parseInt(a.quantity, 10) || 0;
      return sum + price * qty;
    }, 0);
  };

  return (
    <section>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', flexWrap: 'wrap', gap: '10px' }}>
        <div>
          <h3 style={{ margin: 0 }}>Liste des articles</h3>
          <span style={{ fontSize: '0.82rem', color: 'var(--cmd-muted)' }}>
            {DataTable.length} article{DataTable.length !== 1 ? 's' : ''} • Total HT : <strong style={{ color: 'var(--cmd-ink)' }}>{calcTotal().toFixed(2)} MAD</strong>
          </span>
        </div>
        <button
          className="btn-ajoute-interface-commande"
          style={{ background: 'var(--cmd-danger)', color: '#fff', opacity: selectedRows.length === 0 ? 0.5 : 1 }}
          onClick={() => {
            setDataTable(prev => prev.filter(article => !selectedRows.includes(article.id)));
            setSelectedRows([]);
            setErrorQuantities({});
          }}
          disabled={selectedRows.length === 0}
        >
          <i className="bi bi-trash"></i> Supprimer ({selectedRows.length})
        </button>
      </div>

      {DataTable.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '48px 20px', background: 'var(--cmd-bg)', borderRadius: 'var(--cmd-radius)', border: '2px dashed var(--cmd-border)' }}>
          <i className="bi bi-inbox" style={{ fontSize: '2.5rem', color: 'var(--cmd-light)' }}></i>
          <p style={{ color: 'var(--cmd-muted)', marginTop: '12px', fontWeight: 500 }}>Aucun article ajouté pour le moment</p>
        </div>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table className="cmd-table">
            <thead>
              <tr>
                <th style={{ width: '40px' }}>
                  <input
                    type="checkbox"
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelectedRows(DataTable.map(article => article.id));
                      } else {
                        setSelectedRows([]);
                      }
                    }}
                    checked={selectedRows.length === DataTable.length && DataTable.length > 0}
                  />
                </th>
                <th>#</th>
                <th>Référence</th>
                <th>Désignation</th>
                <th>Prix HT</th>
                <th>Quantité</th>
                <th>Stock</th>
                <th>Magasin</th>
                <th>Montant HT</th>
                <th style={{ width: '50px' }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {DataTable.map((article, idx) => {
                const errorMsg = errorQuantities[article.id];
                const price = parseFloat(String(article.prix).replace(',', '.')) || 0;
                const qty = parseInt(article.quantity, 10) || 0;
                return (
                  <tr key={article.id} style={{ background: selectedRows.includes(article.id) ? 'var(--cmd-gold-dim)' : undefined }}>
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedRows.includes(article.id)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedRows(prev => [...prev, article.id]);
                          } else {
                            setSelectedRows(prev => prev.filter(id => id !== article.id));
                          }
                        }}
                      />
                    </td>
                    <td style={{ color: 'var(--cmd-light)', fontWeight: 600 }}>{idx + 1}</td>
                    <td><span className="ref-tag">{article.refArticle}</span></td>
                    <td style={{ maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{article.designation}</td>
                    <td>{price.toFixed(2)} MAD</td>
                    <td>
                      <input
                        type="number"
                        min={1}
                        value={article.quantity}
                        onChange={(e) => {
                          const newQty = e.target.value;
                          if (newQty === '') return;
                          const qtyNum = parseInt(newQty, 10);
                          if (qtyNum > article.Quantité) {
                            setErrorQuantities((prev: any) => ({ ...prev, [article.id]: `Max: ${article.Quantité}` }));
                          } else {
                            setErrorQuantities((prev: any) => { const c = { ...prev }; delete c[article.id]; return c; });
                          }
                          if (qtyNum > 0) {
                            setDataTable(prev => prev.map(item => item.id === article.id ? { ...item, quantity: newQty } : item));
                          }
                        }}
                        className="inputqtecommande"
                        style={{ borderColor: errorMsg ? 'var(--cmd-danger)' : undefined }}
                      />
                    </td>
                    <td>
                      {article.Quantité}
                      {errorMsg && <span style={{ color: 'var(--cmd-danger)', fontSize: '0.72rem', display: 'block' }}>{errorMsg}</span>}
                    </td>
                    <td><span style={{ background: 'var(--cmd-blue-dim)', color: 'var(--cmd-blue)', padding: '3px 10px', borderRadius: '20px', fontSize: '0.78rem', fontWeight: 600 }}>{article.NomMagasin}</span></td>
                    <td><strong>{(price * qty).toFixed(2)}</strong> MAD</td>
                    <td>
                      <i
                        className="bi bi-trash-fill"
                        style={{ color: "var(--cmd-danger)", cursor: "pointer", fontSize: '1.1rem' }}
                        onClick={() => handleDeleteByCoche(article.id)}
                      ></i>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
};

// ---------------------------------------------------------------------------
// Validation
// ---------------------------------------------------------------------------

interface ValidationProps {
  nomClient: string;
  sousClient: string;
  adresse: string;

  DataTable: any[];
}

const Validation: React.FC<ValidationProps> = ({ nomClient, sousClient, adresse, DataTable }) => {
  const styles = StyleSheet.create({
    containerTest: { padding: 30, fontFamily: 'Helvetica' },
    headerContainer: { flexDirection: 'row', justifyContent: 'space-between', marginBottom: 20, borderBottomWidth: 1, borderBottomColor: '#e2e8f0', paddingBottom: 15 },
    bdcTitle: { fontSize: 20, fontWeight: 'bold', color: '#1e293b' },
    infoMagas: { fontSize: 8, color: '#64748b', textAlign: 'right' },
    infoClient: { borderWidth: 1, borderColor: '#cbd5e1', borderRadius: 8, padding: 12, marginBottom: 25, width: '50%' },
    infoClientTitle: { fontSize: 10, fontWeight: 'bold', color: '#475569', marginBottom: 4 },
    text: { fontSize: 9, color: '#334155', marginBottom: 2 },
    title: { fontSize: 13, fontWeight: 'bold', color: '#1e293b', marginBottom: 10 },
    table: { borderWidth: 1, borderColor: '#cbd5e1', borderRadius: 6, overflow: 'hidden' },
    tableRowHeader: { flexDirection: 'row', backgroundColor: '#f1f5f9', borderBottomWidth: 1, borderBottomColor: '#cbd5e1', padding: 6 },
    tableRow: { flexDirection: 'row', borderBottomWidth: 1, borderBottomColor: '#e2e8f0', padding: 6 },
    tableCellHeader: { fontSize: 9, fontWeight: 'bold', color: '#475569' },
    tableCell: { fontSize: 9, color: '#334155' },
    colRef: { width: '25%' },
    colDes: { width: '40%' },
    colPrix: { width: '15%', textAlign: 'right' },
    colNet: { width: '10%' },
    colQte: { width: '10%', textAlign: 'right' },
  });

  const groupedByMagasin = DataTable.reduce((acc: any, item: any) => {
    const magasin = item.NomMagasin || 'Inconnu';
    if (!acc[magasin]) acc[magasin] = [];
    acc[magasin].push(item);
    return acc;
  }, {});

  const PdfDocumentByMagasin = ({ magasin, articles }: { magasin: string, articles: any[] }) => (
    <Document>
      <Page style={styles.containerTest} size="A4">
        {/* Header section with Bon de commande & Info Magasin */}
        <View style={styles.headerContainer}>
          <View>
            <Text style={styles.bdcTitle}>Bon de commande</Text>
            <Text style={{ fontSize: 10, color: '#64748b', marginTop: 4 }}>Magasin : {magasin}</Text>
          </View>
          <View style={styles.infoMagas}>
            <Text>Siège : 684 Bd de la grande hay mohammadi, casablanca, maroc</Text>
            <Text>Fax : 05 22 60 90 85</Text>
            <Text>Site Web : www.pagec.ma</Text>
          </View>
        </View>

        {/* Client Info */}
        <View style={styles.infoClient}>
          <Text style={styles.infoClientTitle}>DÉTAILS CLIENT</Text>
          <Text style={styles.text}>Nom client : {nomClient}</Text>
          <Text style={styles.text}>Adresse : {adresse || 'Non spécifiée'}</Text>

        </View>

        {/* Articles Table */}
        <Text style={styles.title}>Liste des Articles</Text>
        <View style={styles.table}>
          {/* Table Header */}
          <View style={styles.tableRowHeader}>
            <View style={styles.colRef}><Text style={styles.tableCellHeader}>Ref. Article</Text></View>
            <View style={styles.colDes}><Text style={styles.tableCellHeader}>Désignation</Text></View>
            <View style={styles.colPrix}><Text style={[styles.tableCellHeader, { textAlign: 'right' }]}>Prix HT</Text></View>
            <View style={styles.colNet}><Text style={styles.tableCellHeader}></Text></View>
            <View style={styles.colQte}><Text style={[styles.tableCellHeader, { textAlign: 'right' }]}>Qté</Text></View>
          </View>
          
          {/* Table Body */}
          {articles.map((ref: any, index: number) => (
            <View key={index} style={styles.tableRow}>
              <View style={styles.colRef}><Text style={styles.tableCell}>{ref.refArticle || 'null'}</Text></View>
              <View style={styles.colDes}><Text style={styles.tableCell}>{ref.designation || 'null'}</Text></View>
              <View style={styles.colPrix}><Text style={[styles.tableCell, { textAlign: 'right' }]}>{parseFloat(ref.prix || 0).toFixed(2)} MAD</Text></View>
              <View style={styles.colNet}><Text style={styles.tableCell}></Text></View>
              <View style={styles.colQte}><Text style={[styles.tableCell, { textAlign: 'right' }]}>{ref.quantity || 0}</Text></View>
            </View>
          ))}
        </View>
      </Page>
    </Document>
  );

  const [Remarque, setRemarque] = useState<any>();
  const [Erreur, setErreur] = useState("");
  const [Message] = useState("");
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const navigate = useNavigate();
  const MagasinId = localStorage.getItem('MagasinId');
  const MagasinName = localStorage.getItem('MagasinName');
  const TypeUtilisateur = localStorage.getItem('CommercialId') ? 'commercial' : localStorage.getItem('ClientId') ? 'client' : localStorage.getItem('VisiteurId') ? 'visiteur' : 'magasin';
  const [loading, setLoading] = useState(false);

  const [deliveryType, setDeliveryType] = useState<'societe' | 'magasin'>('societe');
  const [retraitMagasins, setRetraitMagasins] = useState<MagasinInfo[]>([]);
  const [selectedMagasin, setSelectedMagasin] = useState<MagasinInfo | null>(null);

  interface SocieteLivraison { id: number; NomSociete: string; AdresseSociete: string; Prix: string; Status: string; Date: string; }
  const [societes, setSocietes] = useState<SocieteLivraison[]>([]);
  const [selectedSociete, setSelectedSociete] = useState<SocieteLivraison | null>(null);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_PHP_APP_URL}/admin/societe-livraison`)
      .then(({ data }) => {
        const active = data.filter((s: SocieteLivraison) => s.Status === 'active');
        setSocietes(active);
        if (active.length > 0) setSelectedSociete(active[0]);
      }).catch(err => console.error('Erreur sociétés:', err));
  }, []);

  useEffect(() => {
    AfficheMagasinsService().getMagasin()
      .then((res) => {
        const filtered = (res.data as MagasinInfo[]).filter(m => m.ReceptionClois === 1);
        setRetraitMagasins(filtered);
        if (filtered.length > 0) setSelectedMagasin(filtered[0]);
      }).catch(err => console.error('Erreur magasins:', err));
  }, []);

  const calculeTotal = () => {
    return DataTable.reduce((total, ref) => total + (ref.prix ? parseFloat(ref.prix) * ref.quantity : 0), 0);
  };

  const Totale = calculeTotal();
  const fraisSociete = selectedSociete && deliveryType === 'societe' ? parseFloat(selectedSociete.Prix || '0') : 0;
  const fraisLivraison = deliveryType === 'societe' ? fraisSociete : 100;
  const totalAvecFrais = parseFloat((Totale + fraisLivraison).toFixed(2));

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData();
    formData.append("adress", adresse);

    formData.append("NomClient", nomClient);
    formData.append("SousClient", sousClient);
    formData.append("Remarque", Remarque);
    formData.append("MethodPayment", "A livraison");
    formData.append("StatutPayment", "Non paye");
    formData.append("TypeUtilisateur", TypeUtilisateur);
    formData.append("TotalHT", calculeTotal().toString());
    formData.append("TotalTTC", totalAvecFrais.toString());
    formData.append("NomMagasin", MagasinName || "");
    formData.append("IdMagasin", MagasinId || "");
    formData.append("ModeLivraison", deliveryType);
    formData.append("FraisLivraison", fraisLivraison.toString());
    formData.append("MagasinRetrait",
      deliveryType === 'magasin' && selectedMagasin
        ? selectedMagasin.NomMagasin
        : selectedSociete ? selectedSociete.NomSociete : 'Société de livraison'
    );
    formData.append("AdresseRetreit",
      deliveryType === 'magasin' && selectedMagasin
        ? selectedMagasin.adresse_de_siege
        : selectedSociete ? selectedSociete.AdresseSociete : 'a la société'
    );
    formData.append("SocieteLivraison", deliveryType === 'societe' && selectedSociete ? selectedSociete.NomSociete : '');

    DataTable.forEach((item, index) => {
      for (const key in item) {
        if (item.hasOwnProperty(key)) {
          formData.append(`detail[${index}][${key}]`, item[key]);
        }
      }
    });

    if (!DataTable.length) return setErreur("Veuillez entrer les informations des articles.");
    if (sousClient.trim() && !adresse.trim()) return setErreur("Veuillez entrer l'adresse.");

    try {
      const response = await axios.post(`${process.env.REACT_APP_PHP_APP_URL}/enregistrerCommande`, formData);
      await axios.post(`${process.env.REACT_APP_PHP_APP_URL}/sendArticleCommande/${response.data.IdBl}`, { DataTable }, {
        headers: { 'Content-Type': 'application/json' }
      });
      setLoading(false);
      setShowSuccessPopup(true);
      setTimeout(() => {
        setShowSuccessPopup(false);
        navigate(`/magasins/${MagasinId}/historiques`);
      }, 2500);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section>
      {showSuccessPopup && (
        <div className="popup-success">
          <div className="popup-content">
            <div className="popup-icon">
              <i className="bi bi-check-circle-fill"></i>
            </div>
            <h5>Votre commande a été effectuée avec succès</h5>
            <p>Veuillez attendre 24h <i className="bi bi-clock-history"></i></p>
          </div>
        </div>
      )}
      <h3>La dernière étape pour valider ta commande</h3>
      {Message && <div className="alert alert-success"><i className="bi bi-check-circle"></i> {Message}</div>}
      {Erreur && <div className="alert alert-danger"><i className="bi bi-exclamation-triangle"></i> {Erreur}</div>}

      {loading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ height: "250px" }}>
          <div className="spinner-border custom-spinner" role="status"></div>
          <span className="loader-charg">Chargement</span>
        </div>
      ) : (
        <>
          <div className="col-12 mt-3">
            <label htmlFor="inputAddress2" className="form-label">Remarque</label>
            <input type="text" className="form-control" id="inputAddress" onChange={e => setRemarque(e.target.value)} />
          </div>

          <div className="delivery-picker">
            <p className="delivery-picker-label">Mode de livraison</p>
            <div className="delivery-options">
              <div
                onClick={() => setDeliveryType('societe')}
                className={`delivery-option ${deliveryType === 'societe' ? 'selected' : ''}`}
              >
                <i className="bi bi-truck"></i>
                <span>Société de livraison</span>
              </div>
              <div
                onClick={() => setDeliveryType('magasin')}
                className={`delivery-option ${deliveryType === 'magasin' ? 'selected' : ''}`}
              >
                <i className="bi bi-shop"></i>
                <span>Retrait en magasin</span>
              </div>
            </div>

            {deliveryType === 'societe' && (
              <div>
                <p className="delivery-sublabel">Sélectionnez la société de livraison :</p>
                {societes.length === 0 ? (
                  <p className="delivery-empty"><i className="bi bi-truck"></i> Aucune société disponible</p>
                ) : societes.map(soc => (
                  <div
                    key={soc.id}
                    onClick={() => setSelectedSociete(soc)}
                    className={`delivery-item ${selectedSociete?.id === soc.id ? 'selected' : ''}`}
                  >
                    <div className="delivery-item-radio" />
                    <div style={{ flex: 1 }}>
                      <div className="delivery-item-title"><i className="bi bi-truck"></i>{soc.NomSociete}</div>
                      <div className="delivery-item-sub"><i className="bi bi-geo-alt-fill"></i> {soc.AdresseSociete}</div>
                      <div className="delivery-item-price">{parseFloat(soc.Prix).toFixed(2)} MAD</div>
                    </div>
                  </div>
                ))}
                <div className="delivery-note blue">
                  <i className="bi bi-info-circle"></i> Livraison à domicile — frais selon la société sélectionnée.
                </div>
              </div>
            )}

            {deliveryType === 'magasin' && (
              <div>
                <p className="delivery-sublabel">Sélectionnez le magasin de retrait :</p>
                {retraitMagasins.length === 0 ? (
                  <p className="delivery-empty"><i className="bi bi-shop"></i> Aucun magasin disponible</p>
                ) : retraitMagasins.map(mag => (
                  <div
                    key={mag.IdMagasin}
                    onClick={() => setSelectedMagasin(mag)}
                    className={`delivery-item ${selectedMagasin?.IdMagasin === mag.IdMagasin ? 'selected' : ''}`}
                  >
                    <div className="delivery-item-radio" />
                    <div style={{ flex: 1 }}>
                      <div className="delivery-item-title">Magasin {mag.NomMagasin}</div>
                      <div className="delivery-item-sub"><i className="bi bi-geo-alt-fill"></i> {mag.adresse_de_siege}</div>
                    </div>
                  </div>
                ))}
                <div className="delivery-note green">
                  <i className="bi bi-info-circle"></i> Frais de préparation de 1% appliqués.
                </div>
              </div>
            )}
          </div>

          <div className="frais-summary">
            <div className="frais-row">
              <span>Sous-total</span><strong>{Totale.toFixed(2)} MAD</strong>
            </div>
            <div className="frais-row frais-livraison">
              <span>{deliveryType === 'societe' && selectedSociete ? `Frais — ${selectedSociete.NomSociete}` : 'Frais de livraison (1%)'}</span>
              <strong>{fraisLivraison.toFixed(2)} MAD</strong>
            </div>
            <div className="frais-divider"></div>
            <div className="frais-total">
              <span>Total</span><span>{totalAvecFrais.toFixed(2)} MAD</span>
            </div>
          </div>

          <div className="btns-valide-commande mt-3">
            <button
              className="ms-3 btn-ajoute-interface-commande"
              onClick={handleSubmit}
              disabled={
                DataTable.length === 0 ||
                (deliveryType === 'societe' && !selectedSociete) ||
                (deliveryType === 'magasin' && !selectedMagasin)
              }
            >
              Valider la commande
            </button>
          </div>

          <section className="mt-4">
            <h4>Bons de commande par magasin</h4>
            {(Object.entries(groupedByMagasin) as [string, any[]][]).map(([magasin, articles]) => (
              <div key={magasin} className="mb-3">
                <PDFDownloadLink
                  document={<PdfDocumentByMagasin magasin={magasin} articles={articles} />}
                  fileName={`bon_de_commande_${magasin}.pdf`}
                  style={{ textDecoration: "none" }}
                >
                  {({ loading }) => (
                    <button className="btn-ajoute-interface-commande">
                      <i className="bi bi-cloud-download"></i> {loading ? "Chargement..." : `Télécharger PDF - ${magasin}`}
                    </button>
                  )}
                </PDFDownloadLink>
              </div>
            ))}
          </section>
        </>
      )}
    </section>
  );
};

export default EspaceCommande;